import type { Device } from '../types';

/** Candidate groups for the Analysis device picker, ordered by device ID. */
export const pinCandidateGroups = (
  current: Device | undefined,
  devices: Device[],
  pinnedIds: ReadonlySet<number>,
): Device[][] => {
  const sameSystem: Device[] = [];
  const sameHomeOrAccount: Device[] = [];
  const other: Device[] = [];

  for (const candidate of devices) {
    if (candidate.id === current?.id || candidate.decommissioned || pinnedIds.has(candidate.id)) continue;

    const sameAccount = !!current?.app_owner_uid && current.app_owner_uid === candidate.app_owner_uid;
    const onSameSystem = sameAccount && !!current?.app_hvac_id
      && current.app_hvac_id === candidate.app_hvac_id;
    // Homes belong to accounts; keep the home match explicit in the rule.
    const inSameHome = sameAccount && !!current?.app_location_id
      && current.app_location_id === candidate.app_location_id;

    if (onSameSystem) sameSystem.push(candidate);
    else if (inSameHome || sameAccount) sameHomeOrAccount.push(candidate);
    else other.push(candidate);
  }

  return [sameSystem, sameHomeOrAccount, other]
    .map((group) => group.sort((a, b) => a.id - b.id))
    .filter((group) => group.length > 0);
};
